var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 18.381,
    height: 18.38,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_29",
    "data-name": "Rect\\xE1ngulo 29",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M15.631,12.881a2.735,2.735,0,0,0-2.024.889L5.451,9.7A2.605,2.605,0,0,0,5.5,9.191a2.666,2.666,0,0,0-.049-.516L13.6,4.6a2.75,2.75,0,1,0-.716-1.851,2.6,2.6,0,0,0,.049.516L4.784,7.34a2.75,2.75,0,1,0,0,3.7l8.146,4.073a2.59,2.59,0,0,0-.049.516,2.75,2.75,0,1,0,2.75-2.75m1.25,2.75a1.266,1.266,0,0,1-1.25,1.25,1.25,1.25,0,1,1,1.25-1.25m-2.5-12.88A1.25,1.25,0,1,1,15.631,4a1.25,1.25,0,0,1-1.25-1.25M4,9.191a1.25,1.25,0,1,1-1.25-1.25A1.252,1.252,0,0,1,4,9.191",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8164b9af74d9f52670db2a4e11fe3ba8.svg";
export { ForwardRef as ReactComponent };